import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './reducers/authReducer';
import {thunk} from 'redux-thunk'; 
import { combineReducers } from 'redux';
import profileSetupReducer from './reducers/profileSetupReducer'
import roadmapReducer from './reducers/roadmapReducer';

// Redux Persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'roadmap'],
};

// Combine reducers
const rootReducer = combineReducers({
  auth: authReducer,
  profileSetup: profileSetupReducer,
   roadmap: roadmapReducer,
});

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with Redux Thunk middleware
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk),
});

const persistor = persistStore(store);

export { store, persistor };
